import {
    NextBestActionRequest,
    RestDataResponseNextBestActionResponse,
    nextBestActionPost,
} from '@cecm-microservices-sdk/core/services/account/next-best-action';
import { getMicroservicesClient } from '@/services/microservices/client';
import type { MicroservicesCountryCode } from './usedCarEligibility';

export async function fetchNextBestActions(
    countryCode: MicroservicesCountryCode,
    payload: NextBestActionRequest,
): Promise<RestDataResponseNextBestActionResponse> {
    const client = getMicroservicesClient(countryCode);

    if (!client.baseUrl) {
        throw new Error(
            `Missing microservices base URL for ${countryCode.toUpperCase()}. Check the runtime configuration for the active environment.`,
        );
    }

    return nextBestActionPost(client, payload);
}
